<div class="view-selection-wrapper">
    <div class="view-selection-button-group-container">
        <mat-button-toggle-group [attr.aria-label]="ariaLabel" [value]="selectedItem" (change)="onItemChange($event.value)">
            <mat-button-toggle
                *ngFor="let item of items"
                class="font-weight-bold"
                [value]="item.route">
                {{ item.label }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</div>